type Category = { name: string; description: string };

export function CategoriesField({
  value,
  onChange,
}: {
  value: Category[];
  onChange: (v: Category[]) => void;
}) {
  function update(idx: number, next: Category) {
    onChange(value.map((r, i) => (i === idx ? next : r)));
  }
  function remove(idx: number) {
    onChange(value.filter((_, i) => i !== idx));
  }
  function add() {
    onChange([...value, { name: "New category", description: "" }]);
  }

  return (
    <div className="space-y-3">
      {value.map((c, i) => (
        <div key={i} className="rounded border p-3 space-y-2 relative">
          <button
            type="button"
            onClick={() => remove(i)}
            className="absolute top-2 right-2 text-xs text-neutral-500 hover:text-red-600"
          >
            ✕
          </button>
          <input
            value={c.name}
            onChange={(e) => update(i, { ...c, name: e.target.value })}
            placeholder="Category name"
            className="w-full rounded border px-2 py-1.5 text-sm font-medium"
          />
          <textarea
            value={c.description}
            onChange={(e) => update(i, { ...c, description: e.target.value })}
            placeholder="Description"
            rows={2}
            className="w-full rounded border px-2 py-1.5 text-sm resize-y"
          />
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        className="text-sm text-neutral-700 hover:text-neutral-900 underline"
      >
        + Add category
      </button>
    </div>
  );
}
